import React from 'react'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function ValueAdded() {
    return (
        <div>
            <div className="backgroundColor-valueAdded text-center mt-5" style={{ background: 'linear-gradient(-135deg, #009ab5 0, #00d8c3 100%)' }}>
                <h1 className='text-white'>Value Added Tools</h1>
                </div>
            <div className="bg-light">
                <div className="container section-5-gst-software mt-5 p-3 text-center">
                    <h2>Key Features of Intelligence Insight</h2>
                    <div className="section-5-gst-software-cards mt-5 p-3">

                        <div className="row">
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3 w-25' src="./assets/images/invoice.png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>GSTN Verification : check GSTN taxpayer details either through number, name or PAN</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3' src="./assets/images/tax (1).png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>HSN Search: find latest HSN code and associated tax rate</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3' src="./assets/images/integration.png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>GST Return Status: check return foiling status</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3' src="./assets/images/cloud-based.png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>GST Calculator: Calculate GST on goods and services</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3' src="./assets/images/high-security.png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>CFO dashboard on Mobile</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3' src="./assets/images/data-management.png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>API utilization on Mobile</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container gstrobo-section-3 bg-light mt-5 text-center pb-5">
                <h1 className='pt-5'><span style={{ color: '#f43f47' }}>GST</span> Products</h1>
                <p className='text-muted'>Ensuring Compliance, Reliability & Efficiency</p>
                <div className="gstrobo-cards">
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/invoice.png" alt="" />
                        <h4 className='mt-3'>GST Software</h4>
                        <Link to='/gst-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/real-time-goods.png" alt="" />
                        <h4 className='mt-3'>E-Way Bill Software</h4>
                        <Link to='/e-way-bill-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/one-click-icon.png" alt="" />
                        <h4 className='mt-3'>E-Invoicing Software</h4>
                        <Link to='/e-invoicing-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/api.png" alt="" />
                        <h4 className='mt-3'>GST & E-Way Bill API</h4>
                        <Link to='/gst-e-way-bill-api'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/reconcile.png" alt="" />
                        <h4 className='mt-3'>Intelligence Insight</h4>
                        <Link to='/intelligence-insight'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/ledger.png" alt="" />
                        <h4 className='mt-3'>Value Added Tools</h4>
                        <Link to='/value-added-tools'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                </div>
            </div>

        </div>
    )
}
